function Banner() {
    return <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
    <div class="container text-center text-md-left" data-aos="fade-up">
      <h1>Welcome to <span>Jalaram Logistics</span></h1>
      <h2>We are team to provide trade and shipping services</h2>
    </div>
  </section>
}

export default Banner;